export default __webpack_public_path__ + "static/media/lions_song.e2559a78.png";